import React from "react";
import CarouselBottomArrow from "../carousel-bottom-arrow";
import H2 from "../h2";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Location from "./images/location.svg";

const  BranchesHubsCarousel = ({
    heading = "CARS24 Hubs in your city",
    headingComponent = H2,
    slidesToShow,
    hubsList = [],
    scrollWidgetGa
}) => {
    const sliderSetting = {
        slidesToShow,
        infinite: false,
        arrow: true,
        afterChange: scrollWidgetGa
    };

    const Heading = headingComponent;

    return (
        <React.Fragment>
            <Heading text={heading} />
            <div styleName={"styles.carouselWrap"}>
                <CarouselBottomArrow
                    settings={sliderSetting}>
                    {
                        hubsList.map((hub, index) => (
                            <div styleName={"styles.cityCard"} key={index} >
                                <div styleName={"styles.locationTitle"}>
                                    <img src={Location} alt="location"/>
                                    <h3>{hub.branchName}</h3>
                                </div>
                                <p>{hub.address}</p>
                            </div>
                        ))
                    }
                </CarouselBottomArrow>
            </div>
        </React.Fragment>
    );
};

BranchesHubsCarousel.propTypes = {
    heading: PropTypes.string,
    headingComponent: PropTypes.object || PropTypes.array,
    slidesToShow: PropTypes.number,
    hubsList: PropTypes.array,
    scrollWidgetGa: PropTypes.func
};

export default BranchesHubsCarousel;
